import { useMemo } from 'react'

import { DEFAULT_LOCALE } from '../../../../../constants/defaultLocale'
import { SortDirection } from '../../../../../enums/sortDirection'
import { useQueryParams } from '../../../../../hooks/useQueryParams'
import { LocaleIdentifier } from '../../../../../types/localeIdentifier'
import { getCurrentLocale } from '../../../../../utils'
import { VatRatesSortProperty } from '../enums/vatRatesSortProperty'

interface VatRatesListFilters {
  acceptLanguage: LocaleIdentifier
  sortDirection: SortDirection
  sortProperty: VatRatesSortProperty
}

type UseVatRatesListFiltersResult = [VatRatesListFilters, (filters: Partial<VatRatesListFilters>) => void]

export const defaultQuery: VatRatesListFilters = {
  acceptLanguage: DEFAULT_LOCALE,
  sortDirection: SortDirection.Asc,
  sortProperty: VatRatesSortProperty.Priority,
}

export const useVatRatesListFilters = (key: string): UseVatRatesListFiltersResult => {
  const locale = getCurrentLocale()
  const [queryParams, setQueryParams] = useQueryParams<VatRatesListFilters>({
    key,
    defaultQuery: {
      ...defaultQuery,
      acceptLanguage: locale,
    },
  })

  return useMemo(() => [queryParams, setQueryParams], [queryParams, setQueryParams])
}
